import cs from './cs'
import def from './default'
import en from './en'

export type Locale = typeof def

export default {
    cs, def, en,
}
